import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
@Pipe({
  name: 'roundAmountTwoDecimal',
})
export class RoundAmountTwoDecimal implements PipeTransform {
  transform(value: any): string {
    if (+value % 1 != 0) {
      return (+value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return (+value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
}
